export const calculatePassingGrade = (passing_score: number, question_length: number): number => {
   const passingPercentage = Math.max(0, Math.min(100, passing_score));
   return Math.ceil((passingPercentage / 100) * question_length);
};
